import { EntityTypeCode, useFetchCallType, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { parseViewerFromMiddleman, setViewer } from 'rahtab-redux/slices/viewerSlice';

export const useViewer = () => {
  const { viewerSelectedEntity } = useViewerEntity();
  const viewer = useSelector((state) => state.viewer);
  const dispatch = useAppDispatch();
  const [refetchProviderInfo, { loading: loadingProviderInfo, error }] = useFetchCallType<{
    Result: ServerProviderInfo;
  }>('ProviderInfo', {
    skip: viewerSelectedEntity ? viewerSelectedEntity.typeCode !== EntityTypeCode.Provider : false,
    onCompleted: (d) => {
      dispatch(setViewer(d));
    },
  });
  const [refetchMiddlemanInfo, { loading: loadingMiddlemanInfo }] = useFetchCallType<{ Result: ServerMiddlemanInfo }>(
    'GetMiddlemanInfo',
    {
      skip: viewerSelectedEntity?.typeCode !== EntityTypeCode.Middleman,
      onCompleted: (d) => {
        dispatch(parseViewerFromMiddleman(d as any));
      },
    },
  );

  return {
    refetch: viewerSelectedEntity?.typeCode === EntityTypeCode.Middleman ? refetchMiddlemanInfo : refetchProviderInfo,
    data: viewer,
    loading: loadingProviderInfo || loadingMiddlemanInfo,
    error,
  };
};

export interface ServerProviderInfo {
  Address: string;
  City: string;
  County: string;
  Email: string;
  FirstName: string;
  Guild: string;
  BirthDate: string;
  GuildRegisterNumber: string;
  Latitude: string;
  Longitude: string;
  MiddlemanImage: string;
  MiddlemanName: string;
  MembershipDate: string;
  MobileNo: string;
  NationalCode: string;
  Phone: string;
  PostalCode: string;
  Province: string;
  LastName: string;
  ProviderImage: string;
  ProviderName: string;
  ProductCount: number;
  RateCont: number;
  Satisfaction: number;
  ProviderCode: string;
  IsMobasherPazirandeh: boolean;
  ProviderType: string;
  UnreadMessageCount: string;
  Status: 'active';
  AccessLevel: 'premium';
  RequestPermission: boolean;
  Identification: string;
  NtswMember: boolean;
  NtswOTPCode: boolean;
  /** basic = 0, premium = 1 */
  Ranking: 0 | 1;
  NtswRoleCode: string;
}

export interface ServerMiddlemanInfo {
  Address: string;

  ChangePasswordForced: boolean;

  City: string;

  County: string;

  Email: string;

  FirstName: string;

  Identification: string;

  LastName: string;

  Latitude: string;

  Longitude: string;

  MembershipDate: string;

  MiddlemanCode: string;

  MiddlemanImage: string;

  MiddlemanName: string;

  MobileNo: string;

  NationalCode: string;

  Phone: string;

  PostalCode: string;

  Province: string;

  RIdentification: string;

  RequestPermission: boolean;

  UnitCode: string;
  NtswOTPCode?: boolean;
  /** basic = 0, premium = 1 */
  Ranking?: 0 | 1;
  NtswRoleCode: string;
}
